<div class="switcher-wrapper">
    <div class="select-wrapper">
        <app-select-box
                [allItems]="statusLayers"
                [selectedItemKey]="statusLayerType"
                [width]="210"
                (selectedItemChanged)="onStatusLayerChange($event)"
        ></app-select-box>

        @if (shouldShowActivityFilter()) {
          <app-select-box
            [allItems]="activityFilters"
            [selectedItemKey]="activityFilter"
            [width]="165"
            [useCircleIcon]="true"
            (selectedItemChanged)="onActivityFilterChange($event)"
          ></app-select-box>
        }

        @if (statusLayerType === StatusLayerType.ROUTE_STATUS && !!routeItems && routeItems.length > 0 && !!routeFilters) {
          <!-- iterate on route path items -->
          @for (filterItems of routeFilters; track $index) {
            <!-- hide route config selection if there is just one -->
            @if ($index > 0 || routeItems.length > 1) {
              <!-- show group select boxes -->
              @if (getSelectedRouteFilter($index); as selectedKey) {
                <app-select-box
                  [allItems]="filterItems"
                  [selectedItemKey]="selectedKey"
                  [width]="200"
                  [useCircleIcon]="true"
                  (selectedItemChanged)="onRouteFilterChange($index, $event)"
                ></app-select-box>
              }
            }
          }
        }
    </div>

    <!-- legends -->
    <div class="legends">
        <!-- show route status legend all the time on Live Map Routes -->
        @if (statusLayerType === StatusLayerType.ROUTE_STATUS) {
          <div class="legend-wrapper">
            <app-route-status-mode-legend
            >
            </app-route-status-mode-legend>
          </div>
        } @else if (statusLayerType === StatusLayerType.GPS_TRACKS) {
          <div class="legend-wrapper">
            <app-gps-tracks-legend
            >
            </app-gps-tracks-legend>
          </div>
        } @else if (statusLayerType === StatusLayerType.CURRENCY) {
          <div class="legend-wrapper">
            <app-currency-legend
            >
            </app-currency-legend>
          </div>
        } @else if (statusLayerType === StatusLayerType.COVERAGE) {
          <div class="legend-wrapper">
            <app-coverage-legend
            >
            </app-coverage-legend>
          </div>
        }

        @if (showTraffic) {
          <div class="legend-wrapper">
            <app-traffic-legend
            >
            </app-traffic-legend>
          </div>
        }

        @if (showRadar || showWarnings) {
          <div class="legend-wrapper">
            <app-weather-legend
            >
            </app-weather-legend>
          </div>
        }

        @if (showDebug) {
          <div class="legend-wrapper">
            <app-debug-box
              (hide)="closeDebugPanel()"
              [mapLayersManager]="mapLayersManager"
            ></app-debug-box>
          </div>
        }
    </div>
</div>






